import React from 'react'
import filter from 'lodash/filter'
import isEmpty from 'lodash/isEmpty'
import map from 'lodash/map'
import { Stack } from 'react-bootstrap'
import RGL, { WidthProvider } from 'react-grid-layout'
import type { ReactGridLayoutProps, WidthProviderProps } from 'react-grid-layout'
import { getWindow } from '@ztechapps/common.utils'
import { BusyButton } from '@ztechapps/webui.button'
import { EmptyContent, ShowIf } from '@ztechapps/webui.util'
import { useDashboardContext } from './Context'
import { GridItem } from './GridItem'
import { WidgetOptions } from './widgetOptions'

const global = getWindow()
const ReactGridLayout = WidthProvider(RGL) as React.ComponentClass<ReactGridLayoutProps & WidthProviderProps>

export const DashboardLayout = () => {
  const { setting, loading, resolveWidget, onUpdateLayout } = useDashboardContext()

  if (loading) return null

  const layout = filter(setting.layout, (item) => !!resolveWidget(item.i))

  // `onLayoutChange` stays unwired: react-grid-layout fires it on mount and on every prop-driven re-layout,
  // which would save a layout nobody moved. Only a finished drag or resize saves.
  return (
    <>
      <ShowIf condition={isEmpty(layout)}>
        <Stack className={'align-items-center justify-content-center'}>
          <EmptyContent
            message={'No widgets for now'}
            subMessage={'Customize your dashboard by adding widgets'}
            action={<WidgetOptions trigger={<BusyButton text={'Add widgets'} icon={'plus'} />} />}
          />
        </Stack>
      </ShowIf>
      <ReactGridLayout
        className="layout"
        layout={layout}
        cols={12}
        rowHeight={1}
        width={global.window.innerWidth}
        onDragStop={onUpdateLayout}
        onResizeStop={onUpdateLayout}
        draggableHandle=".react-grid-dragHandleExample"
      >
        {map(layout, (item, index) => (
          <GridItem key={item?.i ?? index} data-grid={item}></GridItem>
        ))}
      </ReactGridLayout>
    </>
  )
}
